import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../utils/i18n";
import Button from "../ui/Button";
import LanguageSwitcher from "./LanguageSwitcher";
import { Link } from "react-scroll";

const Header = () => {
  const { t } = useTranslation();
  const [isXsView, setIsXsView] = useState(window.innerWidth <= 480);
  const [imageSrc, setImageSrc] = useState("");

  useEffect(() => {
    const handleResize = () => {
      setIsXsView(window.innerWidth < 640);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const updateImageSrc = () => {
      const language = i18n.resolvedLanguage || i18n.language;

      const src = isXsView
        ? language === "en"
          ? "/img/EN_fundedbyEU_VERTICAL_RGB_NEG.webp"
          : language === "mk"
          ? "/img/MK-funded_EU-emblem_NEG.webp"
          : language === "ks"
          ? "/img/KS-Funded_NEG.webp"
          : "/img/KS-Funded_NEG.webp"
        : language === "en"
        ? "/img/EN_FundedbytheEU_RGB_NEG.webp"
        : language === "mk"
        ? "/img/MK-funded_horizontal_EU-emblem_NEG.webp"
        : language === "ks"
        ? "/img/KS-Funded_EU-emblem_NEG.webp"
        : "/img/KS-Funded_EU-emblem_NEG.webp";

      setImageSrc(src);
    };

    updateImageSrc();

    i18n.on("languageChanged", updateImageSrc);
    return () => i18n.off("languageChanged", updateImageSrc);
  }, [isXsView]);

  return (
    <header
      className="relative h-[95vh] bg-cover bg-top"
      style={{
        backgroundImage: `url(/img/lepenec_bg_main.webp)`,
        clipPath: "polygon(0 0, 100% 0, 100% 85vh, 0 100%)",
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-green-950/70 to-green-950/80"></div>

      <LanguageSwitcher />

      <div
        className="absolute top-2 
  xl:top-3 xl:left-3 lg:top-3 lg:left-3 md:top-3 md:left-3 sm:top-3 sm:left-3
  xxs:flex xxs:justify-center xxs:w-full xs:flex xs:justify-center xs:w-full
  md:flex-none md:w-auto lg:flex-none lg:w-auto xl:flex-none xl:w-auto sm:flex-none sm:w-auto"
      >
        <img
          src={imageSrc}
          alt="Logo"
          className="h-16 xl:h-[8.5vh] lg:h-[7vh] md:h-[7vh] sm:h-[7.5vh] xs:h-[17vh] xxs:h-[17vh]"
        />
      </div>
      <div className="absolute top-[8%] xxs:top-[19%] md:top-[10%] xs:top-[19%] sm:top-[10%] lg:top-[10%] xl:top-[9%] left-1/2 transform -translate-x-1/2">
        <img
          src="/img/logo.webp"
          alt="Logo"
          className="aspect-square max-w-none lg:h-[30vh] xxs:h-[21vh] sm:h-[27vh] xs:h-[22vh] md:[h-30vh]"
        />
      </div>

      <div className="absolute w-[60%] xxs:w-[70%] xs:w-[60%] xl:w-auto top-[30%] xxs:top-[40vh] xs:top-[41vh] sm:top-[40vh] md:top-[37vh] xl:top-[40vh] lg:top-[40vh] left-1/2 transform -translate-x-1/2 text-center z-10">
        <h1
          className="font-bold text-white leading-tight"
          style={{
            fontSize: "calc(1.5vw + 2vh)",
          }}
        >
          {t("header.headerTitle")}
        </h1>
        <p
          className="text-gray-200 mt-4 leading-tight"
          style={{
            fontSize: "calc(1vw + 1.5vh)",
          }}
        >
          {t("header.headerSubtitle")}
        </p>
      </div>

      <div className="absolute inset-0 flex items-center justify-center text-gray-700 xxs:top-[57%] xxs:text-[1.5vh] xs:top-[62%] xs:text-[2vh]">
        {/* Use Link component to scroll to 'solutions' section */}
        <Link
          to="solutions"
          smooth={true}
          duration={500}
          offset={-100}
          className=""
        >
          <Button>{t("header.exploreMore")}</Button>
        </Link>
      </div>
    </header>
  );
};

export default Header;
